import { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

export default css`
  .legal-content {
    font-size: 14px;
    line-height: 20px;
    color: ${themeGet('colors.text.body')};

    a {
      color: ${themeGet('colors.primary.main')};
      text-decoration: none;
      font-weight: ${themeGet('fontWeights.1')};
    }

    strong {
      font-weight: ${themeGet('fontWeights.2')};
      color: ${themeGet('colors.text.important')};
    }

    @media screen and (min-width: ${themeGet('breakpoints.1')}) {
      font-size: 20px;
      line-height: 28px;
    }
  }
`
